export * from './examples.service';
import { ExamplesService } from './examples.service';
export * from './login.service';
import { LoginService } from './login.service';
export * from './msgs.service';
import { MsgsService } from './msgs.service';
export * from './specification.service';
import { SpecificationService } from './specification.service';
export const APIS = [ExamplesService, LoginService, MsgsService, SpecificationService];
